const INJECTED_ENV_KEY = "INJECTED_ENV";
export const getEnv = ({ config, getLocalEnv = (key) => process.env[key], onMissingKeys, }) => {
    const { env = [], optionalEnv = [], envPrefix = "" } = config;
    const getEnv = (key) => {
        const injectedValue = window[INJECTED_ENV_KEY]?.[key];
        return injectedValue ?? getLocalEnv(key);
    };
    const regex = new RegExp(`^${envPrefix}`);
    const requiredEntries = env.map((key) => [
        key.replace(regex, ""),
        getEnv(key),
    ]);
    const missingKeys = requiredEntries
        .filter(([_, value]) => value === undefined)
        .map(([key]) => key);
    if (missingKeys.length > 0) {
        onMissingKeys?.(missingKeys);
        throw new Error(`Keys are missing from environment: ${missingKeys}`);
    }
    const optionalEntries = optionalEnv.map((key) => [
        key.replace(regex, ""),
        getEnv(key),
    ]);
    return Object.fromEntries([...requiredEntries, ...optionalEntries]);
};
